// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.table-container[data-v-cafa2ad2]{ padding : 0 5px\n}\n.custom-element-table[data-v-cafa2ad2]{ position: relative;\n}\n.line-photo[data-v-cafa2ad2]{ width: 60px; height: 60px; -o-object-fit: contain; object-fit: contain;\n}\n", ""]);
// Exports
module.exports = exports;
